import { get_gravatar } from './gravatar';

export default function initCommentIdentity() {
    const author = document.querySelector("input#author");
    const email = document.querySelector("input#email");
    const site = document.querySelector("input#url");
    const avatar = document.querySelector("div.comment-user-avatar img");
    const gravatarCheck = document.querySelector(".gravatar-check");
    if (!author || !email || !site || author.dataset.commentIdentityReady) return;
    author.dataset.commentIdentityReady = "true";
    const read = (key) => { try { return localStorage.getItem(key); } catch (error) { return null; } };
    const save = (key, value) => { try { localStorage.setItem(key, value); } catch (error) {} };
    // Discard legacy QQ lookup state; avatars now come only from the email address.
    for (const key of ["user_qq", "user_qq_email", "is_user_qq", "user_avatar"]) {
        try { localStorage.removeItem(key); } catch (error) {}
    }
    for (const [field, key] of [[author, "user_author"], [email, "user_email"], [site, "user_url"]]) {
        if (!field.value) field.value = read(key) || "";
        field.addEventListener("blur", () => save(key, field.value));
    }
    const defaultAvatar = avatar ? avatar.getAttribute("src") : "";
    const updateAvatar = () => {
        if (avatar) avatar.setAttribute("src", email.value ? get_gravatar(email.value, 80) : defaultAvatar);
        if (gravatarCheck) gravatarCheck.style.display = email.value ? "block" : "none";
    };
    email.addEventListener("blur", updateAvatar);
    updateAvatar();
}
